import { ResourceProfileRebuildFeaturePage } from "..";

/** 资源画像重算页面。 */
export function ResourceProfileRebuildPage() {
  return <ResourceProfileRebuildFeaturePage />;
}
